var _dec, _class, _descriptor;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { computed } from '@ember/object';
import Service, { inject as service } from '@ember/service';
let LanguagesService = (_dec = computed('i18n'), _class = class LanguagesService extends Service {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "i18n", _descriptor, this);
  }
  get languagesByLocale() {
    return {
      ca: this.i18n.t('activeLanguages.ca'),
      'ca-ES': this.i18n.t('activeLanguages.ca-ES'),
      en: this.i18n.t('activeLanguages.en'),
      'en-AU': this.i18n.t('activeLanguages.en-AU'),
      'en-CA': this.i18n.t('activeLanguages.en-CA'),
      'en-GB': this.i18n.t('activeLanguages.en-GB'),
      'en-US': this.i18n.t('activeLanguages.en-US'),
      es: this.i18n.t('activeLanguages.es'),
      'es-ES': this.i18n.t('activeLanguages.es'),
      'es-US': this.i18n.t('activeLanguages.es-US'),
      fr: this.i18n.t('activeLanguages.fr'),
      'fr-CA': this.i18n.t('activeLanguages.fr-CA'),
      'fr-FR': this.i18n.t('activeLanguages.fr-FR'),
      ja: this.i18n.t('activeLanguages.ja'),
      'ja-JP': this.i18n.t('activeLanguages.ja-JP'),
      pt: this.i18n.t('activeLanguages.pt'),
      'pt-PT': this.i18n.t('activeLanguages.pt-PT')
    };
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "i18n", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "languagesByLocale", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "languagesByLocale"), _class.prototype), _class);
export { LanguagesService as default };